module.exports = __webpack_public_path__ + "img/zt-img3.38598bfe.png";